import styled from 'styled-components';

export const Container = styled.div`
  // One instance of MultiValue will be rendered for each selected value
  // Show only the first one
  :not(:first-of-type) {
    display: none;
  }
`;
